type LocalizationObject = Record<LocalizationKey, string>;
export const strings: Record<string, LocalizationObject> = {};

export function addLocale(culture: string, localizationObject: LocalizationObject): void {
	strings[culture] = localizationObject;
}